import {
  ColorsV2,
  Flex,
  Icon,
  IconNames,
  RadioTile,
  sizes,
  Text,
  useThemeColors,
} from '@electricjs/arc';
import { DeviceRetrieveAction } from './types';

type DeviceRetrievalTileProps = {
  deviceRetrieveAction: DeviceRetrieveAction;
  value: DeviceRetrieveAction;
  optionText: string;
  priceText?: string;
  additionalPriceText?: string;
  icon: IconNames;
  promotionalChip?: React.ReactNode;
  disabled?: boolean;
};

const DeviceRetrievalTile = ({
  deviceRetrieveAction,
  value,
  optionText,
  priceText,
  additionalPriceText,
  icon,
  promotionalChip,
  disabled = false,
}: DeviceRetrievalTileProps) => {
  const [grayLight, primary] = useThemeColors([
    ColorsV2.GRAY_LIGHT,
    ColorsV2.PRIMARY,
  ]);

  return (
    <RadioTile
      id={`device-retrieval-tile-${value}`}
      height="15rem"
      width="17rem"
      // Arc draws its own grey outline on a disabled tile; keeping ours as
      // well stacks two borders, and the drop shadow reads as enabled.
      border={disabled ? undefined : `1px solid ${grayLight}`}
      borderRadius="8px"
      boxShadow={disabled ? undefined : `0px 4px 8px -2px ${primary}1f`}
      value={value}
      checked={value === deviceRetrieveAction}
      disabled={disabled}>
      <Flex vertical hAlignContent="center">
        <Flex height={sizes.size_40_rem} alignItems="center">
          <Icon
            height="3rem"
            icon={icon}
            size="large"
            mb="1rem"
            // Icon applies its colour as an inline style, which the cascade
            // rule Arc uses for disabled tiles cannot override.
            intent={disabled ? 'disabled' : undefined}
          />
        </Flex>
        <Flex height={sizes.size_40_rem} alignItems="center" mb="0.5rem">
          <Text
            textAlign="center"
            variant="body"
            color="inherit"
            fontWeight="inherit">
            {optionText}
          </Text>
        </Flex>
        {priceText && (
          <Flex vAlignContent="center">
            <Text variant="label-small" color="inherit">
              {priceText}
            </Text>
            {additionalPriceText && (
              <Text variant="body-2" color="inherit">
                {additionalPriceText}
              </Text>
            )}
          </Flex>
        )}
        {!disabled && promotionalChip}
      </Flex>
    </RadioTile>
  );
};

export default DeviceRetrievalTile;
